import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PersonIcon from "@mui/icons-material/Person";
import TableChartIcon from "@mui/icons-material/TableChart";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// import sass file
import "./navbar.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { removeAdminToken } from "../../../utils/auth";

// import images
// import admin from '../../Images/admin_pic.jpg';

function Navbar() {
  const navigate = useNavigate(); // For navigation after logout

  const [toggle, setToggle] = useState(false);
  // color state management using react context

  const handleToggle = () => {
    setToggle(!toggle);
    if (!toggle) {
      // Disable body scroll when the toggle is open
      document.body.style.overflow = "hidden";
    } else {
      // Enable body scroll when the toggle is closed
      document.body.style.overflow = "auto";
    }
  };

  // Logout function

  const handleLogout = async () => {
    try {
      // Remove admin authentication token
      await removeAdminToken();

      // Clear storage
      localStorage.clear();
      sessionStorage.clear();

      // Navigate to admin login page & prevent back navigation
      navigate("/admin/login", { replace: true });

      // Optional: Force a reload to ensure a fresh state
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="navbar">
      <div className="navbar_main">
        <div className="menu_logo">
          {toggle ? (
            <CloseIcon className="menu_icon" onClick={handleToggle} />
          ) : (
            <MenuIcon className="menu_icon" onClick={handleToggle} />
          )}

          <Link to="/" style={{ textDecoration: "none" }}>
            <img src="/LOGOS/Farmology-Logo-e1687720251448.png" alt="Logo" />
          </Link>
        </div>
        {/* <div className="search">
                    <input type="text" placeholder="Search.." />

                    <SearchIcon className="search_icon" />
                </div> */}

        <div className="item_lists">
          {/* <div className="item item_lan">
                        <LanguageIcon className="item_icon" />
                        <p>English</p>
                    </div>
                    <div className="item">
                        {!darkMode ? (
                            <DarkModeIcon
                                className="item_icon"
                                onClick={() => dispatch({ type: 'TOGGLE' })}
                            />
                        ) : (
                            <LightModeIcon
                                className="item_icon white"
                                onClick={() => dispatch({ type: 'TOGGLE' })}
                            />
                        )}
                    </div> */}
          {/* <div className="item">
                        <FullscreenExitIcon className="item_icon" />
                    </div>

                    <div className="item">
                        <ChatBubbleOutlineIcon className="item_icon" />
                        <span className="badge">2</span>
                    </div> */}
          {/* <div className="item">
            <NotificationsNoneIcon className="item_icon" />
            <span className="badge">1</span>
          </div> */}

          <Link to="/admin/admin-profile" style={{ textDecoration: "none" }}>
            <div className="item">
              <img
                className="admin_pic"
                src="/Images/defaultProfileDp.png"
                alt="admin"
              />
            </div>
          </Link>
        </div>
      </div>

      <div className="res_navbar">
        {toggle && (
          <div className="res_nav_menu">
            <div className="res_nav_menuu">
              <div className="links">
                <ul>
                  <p className="spann">Main</p>
                  <Link
                    to="/admin/dashboard"
                    style={{ textDecoration: "none" }}
                  >
                    <li>
                      <DashboardIcon className="icon" /> Dashboard
                    </li>
                  </Link>

                  <p className="spann">lists</p>
                  <Link
                    to="/admin/all-admins"
                    style={{ textDecoration: "none" }}
                  >
                    <li>
                      <PersonIcon className="icon" /> Admins
                    </li>
                  </Link>
                  <Link
                    to="/admin/push-notification"
                    style={{ textDecoration: "none" }}
                  >
                    <li>
                      <FontAwesomeIcon icon={faBell} className="icon" /> Push
                      Notification
                    </li>
                  </Link>
                  <Link
                    to="/admin/recommended-products"
                    style={{ textDecoration: "none" }}
                  >
                    <li>
                      <TableChartIcon className="icon" /> Recommended Products
                    </li>
                  </Link>
                  <Link to="/admin/crop-stage" className="text_none">
                    <li
                    // className={isActive("/admin/crop-stage") ? "active" : ""}
                    >
                      <NotificationsNoneIcon className="icon" /> Crop Stage
                    </li>
                  </Link>

                  {/* <Link to="/products" style={{ textDecoration: 'none' }}>
                                        <li>
                                            <TableChartIcon className="icon" /> Products
                                        </li>
                                    </Link>
                                    <Link to="/orders" style={{ textDecoration: 'none' }}>
                                        <li>
                                            <CreditCardIcon className="icon" /> Orders
                                        </li>
                                    </Link>
                                    <li>
                                        <CreditCardIcon className="icon" /> Balance
                                    </li>
                                    <li>
                                        <BarChartIcon className="icon" /> Status
                                    </li> */}

                  <p className="spann">Seetings</p>

                  <li onClick={handleLogout} style={{ cursor: "pointer" }}>
                    <LogoutIcon className="icon" /> Log Out
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar;
